export default __webpack_public_path__ + "static/media/7.84c0b37c.png";